import http from 'plugins/axios';

export default {
  getList(data) {
    return http.get({
      url: '/la/admin/foundation/getList',
      data
    });
  },
  create(data) {
    return http.post({
      url: '/la/admin/foundation/addFoundation',
      data,
      dataType: 'form'
    });
  },
  update(data) {
    return http.post({
      url: '/la/admin/foundation/update',
      data,
      dataType: 'form'
    });
  },
  getCoinTypeList() {
    return http.get({
      url: '/la/admin/coin/allDisplay'
    });
  },
  createRulescontent(content) {
    return http.post({
      url: '/la/admin/foundation/setFoundationText',
      data: { map: content }
    });
  },
  getRules() {
    return http.get({
      url: '/la/admin/foundation/getFoundationText'
    });
  },
  setBaseConfig(content) {
    return http.post({
      url: '/la/admin/foundation/updateBaseAmount',
      data: content,
      dataType: 'form'
    });
  },
  getBaseAmount() {
    return http.get({
      url: '/la/admin/foundation//getBaseAmount'
    });
  },
  freshFoundationRes(data) {
    return http.post({
      url: '/la/admin/foundation/flushRecs',
      data,
      dataType: 'form'
    });
  },
  setpercent(data) {
    return http.post({
      url: '/la/admin/starplan/setStarPlanPercent',
      data,
      dataType: 'form'
    });
  },
  getpercent(data) {
    return http.get({
      url: '/la/admin/starplan/getStarPlanPercent',
      data
    });
  },
  searchAmount(data) {
    return http.post({
      url: '/la/admin/foundation/searchRecs',
      data,
      dataType: 'form'
    });
  }
};
